import { DashboardMetrics, UserState, UserContext, UserCapabilities } from './dashboardTypes';

export function detectUserState(
  metrics: DashboardMetrics,
  connections: any[]
): UserState {
  const hasRoles = metrics.totalRoles > 0;
  const hasCandidates = metrics.totalCandidates > 0;
  const hasAts = connections && connections.length > 0;

  // New user: No roles, no candidates, no ATS connection
  if (!hasRoles && !hasCandidates && !hasAts) {
    return 'new_user';
  }

  // Empty state: Has ATS connection but no data
  if (hasAts && !hasRoles && !hasCandidates) {
    return 'empty_state';
  }

  // Established user: Substantial data (6+ roles OR 11+ candidates)
  if (metrics.totalRoles > 5 || metrics.totalCandidates > 10) {
    return 'established_user';
  }

  // Growth mode: Some data but not established yet
  return 'growth_mode';
}

/**
 * Build complete user context with multi-ATS support
 */
export function getUserContext(
  userProfile: any,
  metrics: DashboardMetrics,
  connections: any[],
  capabilities: UserCapabilities
): UserContext {
  const state = detectUserState(metrics, connections);
  const activeConnections = connections.filter((c: any) => c.status === 1);
  const hasAtsConnection = activeConnections.length > 0;

  // Track provider-specific connections
  const hasBullhornConnection = activeConnections.some(
    (c: any) => c.provider?.toLowerCase() === 'bullhorn'
  );
  const hasJobAdderConnection = activeConnections.some(
    (c: any) => c.provider?.toLowerCase() === 'jobadder'
  );

  // Get list of connected provider names for display
  const atsProviderNames = activeConnections
    .map((c: any) => {
      const provider = c.provider?.toLowerCase();
      if (provider === 'bullhorn') return 'Bullhorn';
      if (provider === 'jobadder') return 'JobAdder';
      return c.provider || 'Unknown';
    })
    .filter((name: string) => name !== 'Unknown');

  return {
    state,
    hasAtsConnection,
    hasBullhornConnection,
    hasJobAdderConnection,
    atsProviderNames,
    canConnectAts: capabilities.canConnectAts,
    hasSharedRoles: metrics.publicSharedRoles > 0,
    capabilities,
    userProfile,
  };
}
